import { render, staticRenderFns } from "./fee-sheet-rules-grid.vue?vue&type=template&id=13bddf34&"
import script from "./fee-sheet-rules-grid.vue?vue&type=script&lang=ts&"
export * from "./fee-sheet-rules-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports